module.exports = __webpack_public_path__ + "img/25.1.d5d69fe9.jpg";